import React from 'react';
import { ErrorLayout, MainLayout } from '@layouts';
import { ErrorContent } from '@components/Help-Center-Components';
import { ErrorConnection } from '@components/Help-Center-Components/error-connection';
import { HelpCenterPage } from '@sections/Help-Center-Page';
import { getHelpSections } from '@modules/get-data';
import { getErrorContent } from '@libs';
import { PROCESSING_ITEMS } from '@constants';
import * as actions from '@store/actions';

const HelpCenter = (sections) => {
  return <HelpCenterPage data={sections} />;
};

HelpCenter.getLayout = (page, { locale, statusCode, isDisconnect }) => {
  const { translations, query } = page.props;

  if (isDisconnect) {
    return (
      <ErrorLayout>
        <MainLayout>
          <ErrorConnection />
        </MainLayout>
      </ErrorLayout>
    );
  }

  if (statusCode) {
    const error = getErrorContent({ code: statusCode });

    return (
      <ErrorLayout title={translations.t(error.title)}>
        <MainLayout reqQuery={query}>
          <ErrorContent error={error} locale={locale} />
        </MainLayout>
      </ErrorLayout>
    );
  }

  return (
    <MainLayout
      reqQuery={query}
      title={translations.t(`site.help.meta.title`)}
      description={translations.t(`site.help.meta.description`)}>
      {page}
    </MainLayout>
  );
};

HelpCenter.getInitialProps = async ({ res, store, query }) => {
  const { dispatch, getState } = store;
  const {
    settings: { locale },
  } = getState();
  dispatch(actions.clearError('GET_HELP'));
  dispatch(actions.clearError('GET_HELP_CONTENT'));
  const sections = await dispatch(getHelpSections());
  const { errors } = getState();
  const error = errors[PROCESSING_ITEMS.GET_HELP];
  const isNetworkError =
    error?.message === 'Network Error' ||
    error?.message === 'Failed to fetch' ||
    error?.message?.includes('timeout');

  sections.isDisconnect && console.error('No connection while fetching help sections');

  if (sections.isDisconnect || isNetworkError) {
    return { isDisconnect: true, locale };
  }

  if (error) {
    if (res && (error.code === 404 || error.code === 500)) {
      res.statusCode = error.code;
    }

    return { locale, statusCode: error.code || 404, query };
  }

  return { ...sections, locale, statusCode: undefined, query };
};

export default HelpCenter;
